(function () {
  window.dataLayer = window.dataLayer || [];

  var config = window.StoriesEcommerceConfig || {};
  var state = {
    cart: config.cart || null,
  };
  var refreshPromise = null;
  var refreshTimer = null;
  var lastBeginCheckoutAt = 0;

  function parseNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function roundMoney(value) {
    return Math.round(value * 100) / 100;
  }

  function parseCartMoney(value) {
    var number = parseNumber(value);
    return number === null ? null : roundMoney(number / 100);
  }

  function parseCheckoutMoney(value) {
    if (value === null || value === undefined || value === "") return null;

    var stringValue = String(value);
    var number = parseNumber(stringValue);

    if (number === null) return null;

    return stringValue.indexOf(".") > -1 ? roundMoney(number) : roundMoney(number / 100);
  }

  function cleanObject(object) {
    Object.keys(object).forEach(function (key) {
      if (
        object[key] === undefined ||
        object[key] === null ||
        object[key] === "" ||
        (Array.isArray(object[key]) && object[key].length === 0)
      ) {
        delete object[key];
      }
    });

    return object;
  }

  function getCurrency(source) {
    return (
      (source && source.currency) ||
      (state.cart && state.cart.currency) ||
      config.currency ||
      null
    );
  }

  function buildCartItem(item, fallbackQuantity) {
    if (!item) return null;

    var quantity = parseNumber(item.quantity);

    if (quantity === null) {
      quantity = parseNumber(fallbackQuantity);
    }

    if (quantity === null) {
      quantity = 1;
    }

    return cleanObject({
      item_id: String(item.sku || item.id || item.variant_id || item.product_id || ""),
      item_name: item.product_title || item.title || item.name,
      item_brand: item.vendor,
      item_category: item.product_type,
      item_variant:
        item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : undefined,
      price: parseCartMoney(item.final_price != null ? item.final_price : item.price),
      quantity: quantity,
    });
  }

  function buildCheckoutItem(item) {
    if (!item) return null;

    return cleanObject({
      item_id: String(item.sku || item.variant_id || item.product_id || ""),
      item_name: item.title,
      item_brand: item.vendor,
      item_category: item.product_type,
      item_variant:
        item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : undefined,
      price: parseCheckoutMoney(item.final_price != null ? item.final_price : item.price),
      quantity: parseNumber(item.quantity) || 1,
    });
  }

  function buildAddToCartItems(payload) {
    if (!payload) return [];

    if (Array.isArray(payload.items)) {
      return payload.items.map(buildCartItem).filter(Boolean);
    }

    return [buildCartItem(payload)].filter(Boolean);
  }

  function buildCartItems(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];

    return cart.items.map(buildCartItem).filter(Boolean);
  }

  function applyAddToCartToState(payload) {
    var addedItems = Array.isArray(payload && payload.items) ? payload.items : payload ? [payload] : [];

    if (!state.cart || !Array.isArray(state.cart.items) || !addedItems.length) {
      return;
    }

    addedItems.forEach(function (addedItem) {
      var itemId = String(addedItem.id || addedItem.variant_id || "");
      var quantity = parseNumber(addedItem.quantity) || 1;
      var linePrice =
        parseNumber(addedItem.final_line_price) ||
        (parseNumber(addedItem.final_price != null ? addedItem.final_price : addedItem.price) || 0) *
          quantity;
      var existingItem = state.cart.items.find(function (cartItem) {
        return String(cartItem.id || cartItem.variant_id || "") === itemId;
      });

      if (existingItem) {
        existingItem.quantity = (parseNumber(existingItem.quantity) || 0) + quantity;
      } else {
        state.cart.items.push(Object.assign({}, addedItem));
      }

      state.cart.item_count = (parseNumber(state.cart.item_count) || 0) + quantity;
      state.cart.total_price = (parseNumber(state.cart.total_price) || 0) + linePrice;
    });
  }

  function pushEvent(eventName, ecommerce) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: eventName,
      ecommerce: ecommerce,
    });
  }

  function setCart(cart) {
    if (cart && Array.isArray(cart.items)) {
      state.cart = cart;
    }

    return state.cart;
  }

  function refreshCart() {
    if (config.pageType === "checkout") {
      return Promise.resolve(state.cart);
    }

    if (refreshPromise) {
      return refreshPromise;
    }

    refreshPromise = fetch("/cart.js", {
      headers: {
        Accept: "application/json",
      },
      credentials: "same-origin",
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Unable to refresh cart");
        return response.json();
      })
      .then(function (cart) {
        return setCart(cart);
      })
      .catch(function (error) {
        console.warn("Stories ecommerce cart refresh failed", error);
        return state.cart;
      })
      .finally(function () {
        refreshPromise = null;
      });

    return refreshPromise;
  }

  function scheduleCartRefresh() {
    if (config.pageType === "checkout") return;

    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      refreshCart();
    }, 150);
  }

  function trackAddToCart(payload) {
    var items = buildAddToCartItems(payload);

    if (!items.length) return;

    applyAddToCartToState(payload);

    var value = roundMoney(
      items.reduce(function (total, item) {
        return total + (item.price || 0) * (item.quantity || 1);
      }, 0)
    );

    pushEvent("add_to_cart", {
      currency: getCurrency(payload),
      value: value,
      items: items,
    });

    scheduleCartRefresh();
  }

  function trackBeginCheckout(cart) {
    var sourceCart = cart && Array.isArray(cart.items) ? cart : state.cart;

    if (!sourceCart || !Array.isArray(sourceCart.items) || !sourceCart.items.length) {
      return;
    }

    var items = buildCartItems(sourceCart);
    var value = parseCartMoney(sourceCart.total_price);
    var coupon = Array.isArray(sourceCart.cart_level_discount_applications)
      ? sourceCart.cart_level_discount_applications
          .map(function (discount) {
            return discount && discount.title;
          })
          .filter(Boolean)
          .join(", ")
      : undefined;

    pushEvent(
      "begin_checkout",
      cleanObject({
        currency: getCurrency(sourceCart),
        value: value,
        coupon: coupon,
        items: items,
      })
    );
  }

  function triggerBeginCheckout() {
    var now = Date.now();

    if (now - lastBeginCheckoutAt < 500) {
      return;
    }

    lastBeginCheckoutAt = now;

    if (state.cart && Array.isArray(state.cart.items) && state.cart.items.length) {
      trackBeginCheckout(state.cart);
      return;
    }

    refreshCart().then(function (cart) {
      trackBeginCheckout(cart);
    });
  }

  function trackPurchase(checkout) {
    if (!checkout || !Array.isArray(checkout.line_items) || !checkout.line_items.length) {
      return;
    }

    var transactionId = checkout.order_id || checkout.order_number || checkout.id || checkout.token;

    if (!transactionId) return;

    var storageKey = "stories-ecommerce-purchase-" + transactionId;

    try {
      if (window.sessionStorage.getItem(storageKey)) {
        return;
      }
    } catch (error) {
      console.warn("Stories ecommerce purchase dedupe read failed", error);
    }

    var items = checkout.line_items.map(buildCheckoutItem).filter(Boolean);

    pushEvent(
      "purchase",
      cleanObject({
        transaction_id: String(transactionId),
        affiliation: config.affiliation || config.shopName,
        currency: getCurrency(checkout),
        value: parseCheckoutMoney(checkout.total_price),
        tax: parseCheckoutMoney(checkout.tax_price || checkout.total_tax),
        shipping: parseCheckoutMoney(
          checkout.shipping_price ||
            (checkout.shipping_rate && checkout.shipping_rate.price) ||
            (checkout.shipping_line && checkout.shipping_line.price)
        ),
        coupon: checkout.discount && checkout.discount.code ? checkout.discount.code : undefined,
        items: items,
      })
    );

    try {
      window.sessionStorage.setItem(storageKey, "1");
    } catch (error) {
      console.warn("Stories ecommerce purchase dedupe write failed", error);
    }
  }

  function bindBeginCheckoutListeners() {
    if (config.pageType === "checkout") return;

    document.addEventListener(
      "click",
      function (event) {
        var trigger = event.target.closest(
          '[name="checkout"], a[href="/checkout"], a[href$="/checkout"]'
        );

        if (!trigger) return;

        triggerBeginCheckout();
      },
      true
    );

    document.addEventListener(
      "submit",
      function (event) {
        var form = event.target;

        if (!form || !form.matches("form")) return;

        if (form.querySelector('[name="checkout"]') || /\/checkout(?:\?|$)/.test(form.action || "")) {
          triggerBeginCheckout();
        }
      },
      true
    );
  }

  document.addEventListener("cart:updated", scheduleCartRefresh);
  bindBeginCheckoutListeners();

  window.StoriesEcommerce = {
    refreshCart: refreshCart,
    setCart: setCart,
    trackAddToCart: trackAddToCart,
    trackBeginCheckout: trackBeginCheckout,
    trackPurchase: trackPurchase,
  };
})();
